import { skipToken } from '@reduxjs/toolkit/query'
import { useParams } from 'react-router-dom'

import { useGetPatientQuery } from '@/core/services/patient'

import { IdentityStatusBadge } from './IdentityStatusBadge'

export function IdentityStatus() {
  const { patientId } = useParams<{ patientId: string }>()
  const { data: patient } = useGetPatientQuery(patientId ?? skipToken)

  if (!patient) return null

  return <IdentityStatusBadge status={patient.identityStatus} />
}
